export default __webpack_public_path__ + "static/media/question.28d7fc20.svg";